import { useContext, useState } from "react";
import { AppContext } from "../Context";

function ParamContrast() {
    const { state } = useContext(AppContext);
    const { dispatch } = useContext(AppContext);
    const contrasts = [{ id: "noContrast", caption: "No Contrast", img: "noContrast.svg", active: true }, { id: "whiteCollarCuff", caption: "White Collar And Cuff", img: "whiteCollarCuff.svg", active: false }, { id: "whiteCollar", caption: "White Collar", img: "whiteCollar.svg", active: false }, { id: "whiteCuff", caption: "White Cuff", img: "whiteCuff.svg", active: false }];

    function onItemClick(id) {
        dispatch({ type: "SET_CONTRAST", payload: id })
        if (id == "noContrast") {
            dispatch({ type: "SET_CONTRAST_PRICE", payload: 0 });
        } else {
            dispatch({ type: "SET_CONTRAST_PRICE", payload: 10 });
        }
        dispatch({ type: "SET_DONE", payload: true });
    }
    return (
        <div className="paramItem">
            <div className="paramHeader">
                <div className="paramTitle">Contrast Fabric</div>
                <div className="paramPrice">+$10</div>
            </div>
            <div className="monoList">
                {contrasts.map((contrast, index) => (
                    <div key={index} className="subMenuType" onClick={() => { onItemClick(contrast.id) }}>
                        <img className="fabricImg" src={`${process.env.PUBLIC_URL}/images/${contrast.img}`} />
                        <div className="subMenuLabel">{contrast.caption}</div>
                        {state.contrast === contrast.id && (
                            <img className="tick" src={process.env.PUBLIC_URL + "/images/tick.svg"} width={20} alt="selected" />
                        )}
                    </div>
                ))}
            </div>
        </div>
    )
}
export default ParamContrast